import React from 'react';
import { Card, Col, Input, Row, Table } from 'antd';

import moment from 'moment';

import debounce from 'debounce';

import { withRouter } from 'react-router-dom';

import { _getUsers, _getSearchUser } from '../../services';
// import history from '../../history';

class UserList extends React.Component{

	render(){

		const columns = [{
			title: 'Email',
			dataIndex: 'local.email',
			key: 'localEmail',
		}, {
			title: 'Registered Date',
			dataIndex: "dateCreated",
			key: "dateCreated",
			render: ( text, record ) => {
				return moment( text ).format('DD/MM/YYYY');
			}
		}, {
			title: 'Verified',
			dataIndex: "verifiedEmail",
			key: "verifiedEmail",
			render: ( text ) => {
				if( text ){
					return null;
				}

				return "FALSE";
			}
		}, {
			title: 'Supplier',
			dataIndex: "supplier",
			key: "supplier",
			render: ( text ) => {
				if( text ){
					return "SUPPLIER";
				}

				return null;
			}
		}, {
			title: 'Ghost',
			dataIndex: "ghost",
			key: "ghost",
			render: ( text ) => {
				if( text ){
					return "GHOST";
				}

				return null;
			}
		}, {
			title: 'Action',
			key: 'action',
			render: ( text, record ) => {
				return (
					<a target={record._id} href={`/user/${record._id}`}>Manage</a>
				)
			}
		}];

		const { data, loading, usersSearched } = this.state;

		return (
			<Card ref={ node => this.elemNode = node } title={ this.renderTitle() }>

				<Table 
					loading={loading}
					pagination={{
						pageSize: 40,
						total: this.state.totalUsers,
						current: parseInt(this.state.page, 10),
						onChange: this.handleOnClickNewPage
					}}
					columns={columns} 
					dataSource={usersSearched.length > 0 ? usersSearched: data } />

			</Card>
		);

	}

	renderTitle = () => {

		const query = this.extractQueryParams( this.props.location.search )

		return (
			<Row gutter={8} type="flex" align="middle">
				<Col>
					<strong>User List</strong>
				</Col>
				<Col>
					<Input 
						defaultValue={query.search}
						style={{ width: 180 }} 
						onChange={ this.handleOnSearch } 
						placeholder="User email" />
				</Col>
			</Row>
		)
	}

	constructor( props ){
		super( props );

		this.state = {
			page: props.page || 1,
			data: [],
			usersSearched: [],
			loading: false
		}

		// this.searchUsers = debounce(this.searchUsers, 500);
		this.setUrlAsync = debounce( this.setUrlAsync, 500 );

		this.pollUsers();

	}
	
	componentDidMount(){

		this.handleOnChangeUrl( this.props.location );

		this.props.history.listen((location) => {

			this.handleOnChangeUrl( location );

		})

	}

	extractQueryParams = ( queryString ) => {
		return queryString.replace('?', '').split('&').reduce(
			( acc, cur ) => {

				const tmpSplit = cur.split('=');

				return {
					...acc,
					[tmpSplit[0]]:tmpSplit[1]
				}
			}, {}
		)
	}

	handleOnChangeUrl = ( location ) => {
		const query = this.extractQueryParams( location.search )

		if( query.search ){
			this.searchUsers( query.search );
		} else {
			this.getUsers();
		}
	}

	handleOnClickNewPage = ( page ) => {
		this.setState({ page, data: [], usersSearched:[] }, () => {
			
			const query = this.extractQueryParams( this.props.location.search );

			this.props.history.push(`/users/${page}${query && query.search? `?search=${query.search}`: ``}`);

		});
	}

	handleOnSearch = ( e ) => {

		// this.setState({
		// 	searchParam: e.target.value
		// }, () => {
		// 	// this.props.history.push('/users');
		if(!e.target.value){
			this.setUrlAsync( { page: 1, url: `/users/1`} );
		} else {

			this.setUrlAsync( { page: 1, url: `/users/1?search=${e.target.value}`} );
			// this.searchUsers( e.target.value );
		}
		// });

	}

	getUsers = ( showLoad = true ) => {

		if( showLoad ){
			this.setState(
				{ loading: true }
			);
		}

		_getUsers(  this.state.page )
			.then( res => {
				this.setState({
					usersSearched:[],
					data: res.data.users,
					totalUsers: res.data.count,
					loading: false
				})
			})

	}

	pollUsers = () => {
		setTimeout( () => {
			
			const query = this.extractQueryParams( this.props.location.search )

			if( query.search ){
				this.searchUsers( query.search )
			} else {
				this.getUsers( false );
			}
			// if there is a search param
				// search user
			// else
				// get users
			
			this.pollUsers();

		}, 5000);
		
	}

	searchUsers = ( searchParam ) => {

		this.setState({ loading: true });
		// this.props.history.push('/users/1');

		_getSearchUser( searchParam, this.state.page )
			.then( res => {
				this.setState({ 
					page: this.state.page,
					totalUsers: res.data.count,
					usersSearched: res.data.users,
					loading: false
				})
			})
	}
	
	setUrlAsync = ( { page, url } ) => {
		this.setState({ page });
		this.props.history.push( url );
	}

}

export default withRouter(UserList);


// WEBPACK FOOTER //
// ./src/components/user/list.js